
<script>

const serverErrorReturn = async (getServerErrors) => {
    let returnHTMLString = ""
    // getServerErrors will be dictionary (serializer.errors)
    try{
        for (const [key, value] of Object.entries(getServerErrors)) {
            // value will be a list
            returnHTMLString = returnHTMLString + "<p>" + key + "</p>"
            for(let i=0;i<value.length;i++){
                let item = value[i]
                returnHTMLString = returnHTMLString + "<p style='color: red;'>" + item + "</p>"
            }
        }
    }catch(e){}
    return returnHTMLString
}


export default serverErrorReturn;
</script>

<style scoped>

</style>
